import { Title } from '@components';
import { listenBYOThemes, listenLightsStatus, listenQueueLength } from './store/FirebaseListeners';

export default {
  name: "App",
  components: {
    Title
  },
  created () {
    this.$vuetify.theme.dark = true;
    listenBYOThemes();
    listenLightsStatus();
    listenQueueLength();
  }
}
